import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import db from "../../firebase";
import { Helmet } from "react-helmet-async";
import BucketRoomPage from "../../widgets/BucketRoom/BucketRoomPage";

const BucketWrappedRoomPage: React.FC = () => {
  const { roomId } = useParams<{ roomId: string }>();

  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [roomType, setRoomType] = useState<"bucket" | "poker" | null>(null);
  const [roomName, setRoomName] = useState<string>("");

  useEffect(() => {
    (async () => {
      if (!roomId) return;
      setLoading(true);
      setNotFound(false);

      const ref = doc(db, "rooms", roomId);
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        setNotFound(true);
        setLoading(false);
        return;
      }

      const data = snap.data() as any;
      setRoomName(data.roomName || "");
      setRoomType(data.roomType ?? "poker");
      setLoading(false);
    })();
  }, [roomId]);

  if (!roomId) return null;
  if (loading) return null;
  if (notFound) return <div>Room not found</div>;

  if (roomType !== "bucket") {
    return <Navigate to={`/room/${roomId}`} replace />;
  }

  return (
    <>
      <Helmet>
        <title>{roomName ? `${roomName} — Bucket • Pokerly` : `Bucket Room ${roomId} — Pokerly`}</title>
        <meta name="description" content={`Bucket-комната Pokerly: ${roomName || roomId}.`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://pokerly.ru/bucket/${roomId}`} />
        <meta property="og:title" content={roomName ? `${roomName} — Bucket • Pokerly` : `Bucket Room ${roomId} — Pokerly`} />
        <meta property="og:description" content={`Оцените задачи в bucket-режиме: ${roomName || roomId}.`} />
        <meta property="og:image" content="https://pokerly.ru/og-image.png" />
      </Helmet>

      <BucketRoomPage />
    </>
  );
};

export default BucketWrappedRoomPage;
